import { nanoid } from 'nanoid/non-secure';

export const initSessionId = () => {
    if (!window.sessionId) {
        // Get existing sessionId from URL params if present
        const urlParams = new URLSearchParams(window.location.search);
        const existingSessionId = urlParams.get('sessionId');

        if (existingSessionId) {
            window.sessionId = existingSessionId;
        } else {
            window.sessionId = nanoid();
        }
    }
};
